import { render, staticRenderFns } from "./CrearSolicitud.vue?vue&type=template&id=6bbbf644&scoped=true&"
import script from "./CrearSolicitud.vue?vue&type=script&lang=js&"
export * from "./CrearSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./CrearSolicitud.vue?vue&type=style&index=0&id=6bbbf644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbf644",
  null
  
)

export default component.exports